<div class="columns small-12 medium-8" data-cy="internetModemSafetyDescription">
  <p>
    {{ 'internet.settings.safety.description' | translate }}
    <strong>{{ 'internet.settings.safety.description2' | translate }}</strong>
    <br />
    <a href="{{ 'internet.settings.safety.more-info.url' | translate }}" target="_blank">
      {{ 'internet.settings.safety.more-info.link' | translate }}
    </a>
  </p>
  <div class="rs-flex-row">
    <!-- High safety -->
    <div class="rs-flex-columns small-12 medium-6" data-cy="internetModemSafetyHighSafety">
      <div class="rs-sbox" (click)="cacheProfileSelect = NORMAL; updateRadioButtons()">
        <input
          #highSecurity
          id="radioHigh"
          type="radio"
          name="radioHigh"
          [disabled]="!technicalProfile"
          data-cy="internetModemSafetyHighSafetyButton"
        />
        <label for="radioHigh">
          <span class="rs-sbox-maincontent">
            <span class="rs-sbox-check-header">
              <span class="rs-sbox-check"></span>
              <span class="rs-sbox-check-content">
                <strong>{{ 'internet.settings.safety.high.title' | translate }}</strong
                ><br />{{ 'internet.settings.safety.high.description' | translate }}
              </span>
            </span>
          </span>
        </label>
      </div>
    </div>

    <!-- Low safety -->
    <div class="rs-flex-columns small-12 medium-6" data-cy="internetModemSafetyLowSafety">
      <div class="rs-sbox" (click)="cacheProfileSelect = BASIC; updateRadioButtons()">
        <input
          #lowSecurity
          id="radioLow"
          type="radio"
          name="radioLow"
          [disabled]="!technicalProfile"
          data-cy="internetModemSafetyLowSafetyButton"
        />
        <label for="radioLow">
          <span class="rs-sbox-maincontent">
            <span class="rs-sbox-check-header">
              <span class="rs-sbox-check"></span>
              <span class="rs-sbox-check-content">
                <strong>{{ 'internet.settings.safety.low.title' | translate }}</strong
                ><br />{{ 'internet.settings.safety.low.description' | translate }}
              </span>
            </span>
          </span>
        </label>
      </div>
    </div>
  </div>

  <!-- Submit button -->
  <div *ngIf="technicalProfile">
    <button
      class="rs-btn"
      type="submit"
      class="rs-btn"
      (click)="dispatchModemSafetySettings()"
      [disabled]="!profileChanged"
      [ngClass]="{ 'rs-btn-disabled': !profileChanged }"
      data-tms-event="button-click"
      attr.data-tms-button-zone="{{ cacheProfile === 'NORMAL' ? 'high' : 'low' }} {{
        'internet.settings.safety.title' | translate
      }}"
      data-tms-button-name="confirm"
      data-cy="internetModemSafetySubmit"
    >
      {{ 'internet.settings.password.confirm' | translate }}
    </button>
  </div>

  <!-- Confirmation message after you call service -->
  <px-alert [alertKey]="'updateModemSafetyAlert'" data-cy="modemSafetyAlert"></px-alert>
</div>
